export enum FontFamily {
  PPP_GRAM_SANS = 'PPPangramSans',
  INTER = 'Inter',
}
